var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "dashboard-GAG" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass:
            "grid grid--jc-between grid--ai-middle mg mg--b-4 mg--t-2"
        },
        [
          _c("p", { staticClass: "headline-large" }, [
            _vm._v(_vm._s(_vm.$t("dashboard.GAG.title")))
          ]),
          _c(
            "button",
            {
              staticClass: "mainBlue mg mg--r-2",
              on: { click: _vm.getDocument }
            },
            [_vm._v(_vm._s(_vm.$t("dashboard.GAG.downloadData")))]
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "grid mg" },
        [
          _c("ma-date-picker", {
            staticClass: "input-date mg mg--r-6",
            attrs: {
              type: "range",
              icon: "calendar",
              literal: _vm.$t("dashboard.GAG.filters.startDate"),
              handleChangeInput: _vm.handleChangeInputStartDate,
              defaultValue: _vm.defaultDateStart,
              dateMax: _vm.today,
              weekDays: _vm.disabledStartDays
            }
          }),
          _c("ma-date-picker", {
            staticClass: "input-date mg mg--r-6",
            attrs: {
              type: "range",
              icon: "calendar",
              literal: _vm.$t("dashboard.GAG.filters.endDate"),
              handleChangeInput: _vm.handleChangeInputEndDate,
              defaultValue: _vm.defaultDateEnd,
              dateMin: _vm.minDate,
              dateMax: _vm.maxDate,
              cleanData: _vm.cleanData,
              weekDays: _vm.disabledEndDays
            }
          }),
          _c("ma-input-select", {
            staticClass: "input-select",
            attrs: {
              type: "select",
              name: "ordeByFilter",
              col: "1",
              icon: "house",
              literal: _vm.$t("dashboard.GAG.filters.orderBy"),
              options: _vm.orderByOptions,
              value: _vm.filtersData.orderBy,
              nullValue: ""
            },
            on: { change: _vm.handleOrderByFilterChange }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "view-wrapper" },
        [
          _c("div", { staticClass: "grid mg mg--b-6" }, [
            _c("div", { staticClass: "grid__cell-md-1" }, [
              _c("p", { staticClass: "text-small mg mg--b-1" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.GAG.kpis.gag")))
              ]),
              _c("p", { staticClass: "headline-large blueDark" }, [
                _vm._v(_vm._s(_vm.gagKpi))
              ])
            ]),
            _c("div", { staticClass: "grid__cell-md-1" }, [
              _c("p", { staticClass: "text-small mg mg--b-1" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.GAG.kpis.TE")))
              ]),
              _c("p", { staticClass: "headline-large blueDark" }, [
                _vm._v(_vm._s(_vm.kpis.TE))
              ])
            ]),
            _c("div", { staticClass: "grid__cell-md-1" }, [
              _c("p", { staticClass: "text-small mg mg--b-1" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.GAG.kpis.gagWeek")))
              ]),
              _c("p", { staticClass: "headline-large blueDark" }, [
                _vm._v(_vm._s(_vm.gagUserKpi))
              ])
            ]),
            _c("div", { staticClass: "grid__cell-md-1" }, [
              _c("p", { staticClass: "text-small mg mg--b-1" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.GAG.kpis.gagSans")))
              ]),
              _c("p", { staticClass: "headline-large blueDark" }, [
                _vm._v(_vm._s(_vm.gagSinisterKpi))
              ])
            ])
          ]),
          _c("div", { staticClass: "table-wrapper" }, [
            _c("table", { staticClass: "table" }, [
              _c("thead", [
                _c("tr", { staticClass: "bg-blueLight" }, [
                  _c("th", {
                    staticClass: "border-right",
                    attrs: { colspan: "2" }
                  }),
                  _c("th", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium white" }, [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.GAG.table.headers.conversion"))
                      )
                    ])
                  ]),
                  _vm.selectedWeeks.length
                    ? _c(
                        "th",
                        {
                          staticClass: "border-right",
                          attrs: { colspan: _vm.selectedWeeks.length }
                        },
                        [
                          _c("p", { staticClass: "text-medium white" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("dashboard.GAG.table.headers.weeks")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c("th", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium white" }, [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.GAG.table.headers.total"))
                      )
                    ])
                  ]),
                  _c("th", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium white" }, [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.GAG.table.headers.evolution"))
                      )
                    ])
                  ]),
                  _vm.selectedWeeks.length
                    ? _c(
                        "th",
                        {
                          staticClass: "border-right",
                          attrs: { colspan: _vm.selectedWeeks.length }
                        },
                        [
                          _c("p", { staticClass: "text-medium white" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("dashboard.GAG.table.headers.weeks")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c("th", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium white" }, [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.GAG.table.headers.total"))
                      )
                    ])
                  ]),
                  _c("th", { staticClass: "border-right" }, [
                    _c("p", { staticClass: "text-medium white" }, [
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.GAG.table.headers.evolution"))
                      )
                    ])
                  ])
                ])
              ]),
              _c("thead", [
                _c(
                  "tr",
                  { staticClass: "bg-blueDark" },
                  [
                    _c("th", { staticClass: "border-right" }, [
                      _c("p", { staticClass: "text-medium white" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dashboard.GAG.table.headers.manager"))
                        )
                      ])
                    ]),
                    _c("th", { staticClass: "border-right" }, [
                      _c("p", { staticClass: "text-medium white" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dashboard.GAG.table.headers.TMO"))
                        )
                      ])
                    ]),
                    _c("th", { staticClass: "border-right" }, [
                      _c("p", { staticClass: "text-medium white" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("dashboard.GAG.table.headers.conversion")
                          )
                        )
                      ])
                    ]),
                    _vm._l(_vm.selectedWeeks, function(week) {
                      return _c("th", { staticClass: "border-right" }, [
                        _c("p", { staticClass: "text-medium white" }, [
                          _vm._v(_vm._s(week))
                        ])
                      ])
                    }),
                    _c("th", { staticClass: "border-right" }, [
                      _c("p", { staticClass: "text-medium white" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dashboard.GAG.table.headers.totalGAG"))
                        )
                      ])
                    ]),
                    _c("th", { staticClass: "border-right" }, [
                      _c("p", { staticClass: "text-medium white" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("dashboard.GAG.table.headers.evolution")
                          )
                        )
                      ])
                    ]),
                    _vm._l(_vm.selectedWeeks, function(week) {
                      return _c("th", { staticClass: "border-right" }, [
                        _c("p", { staticClass: "text-medium white" }, [
                          _vm._v(_vm._s(week))
                        ])
                      ])
                    }),
                    _c("th", { staticClass: "border-right" }, [
                      _c("p", { staticClass: "text-medium white" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dashboard.GAG.table.headers.totalTE"))
                        )
                      ])
                    ]),
                    _c("th", { staticClass: "border-right" }, [
                      _c("p", { staticClass: "text-medium white" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("dashboard.GAG.table.headers.evolution")
                          )
                        )
                      ])
                    ])
                  ],
                  2
                )
              ]),
              _vm.hasData
                ? _c(
                    "tbody",
                    _vm._l(_vm.GAGData.rows, function(row, index) {
                      return _c(
                        "tr",
                        [
                          _c("td", [
                            _c("p", { staticClass: "text-medium blackLight" }, [
                              _vm._v(_vm._s(row.username))
                            ])
                          ]),
                          _c("td", { staticClass: "border-right" }, [
                            _c("p", { staticClass: "text-medium blackLight" }, [
                              _vm._v(_vm._s(row.tmo))
                            ])
                          ]),
                          _c("td", { staticClass: "border-right" }, [
                            _c("p", { staticClass: "text-medium blackLight" }, [
                              _vm._v(_vm._s(row.conversion) + " %")
                            ])
                          ]),
                          _vm._l(row.weeks_data, function(week) {
                            return _c("td", { staticClass: "border-right" }, [
                              _c(
                                "p",
                                { staticClass: "text-medium blackLight" },
                                [_vm._v(_vm._s(week.sinister_gag_count))]
                              )
                            ])
                          }),
                          _c("td", { staticClass: "border-right" }, [
                            _c("p", { staticClass: "text-medium blackLight" }, [
                              _vm._v(_vm._s(row.gag_total))
                            ])
                          ]),
                          _c("td", { staticClass: "border-right" }, [
                            _c("div", { staticClass: "canvas-wrapper" }, [
                              _vm.selectedWeeks.length > 1
                                ? _c("canvas", {
                                    attrs: { id: "gag-count-graph_" + index }
                                  })
                                : _vm._e()
                            ])
                          ]),
                          _vm._l(row.weeks_data, function(week) {
                            return _c("td", { staticClass: "border-right" }, [
                              _c(
                                "p",
                                { staticClass: "text-medium blackLight" },
                                [_vm._v(_vm._s(week.sinister_count))]
                              )
                            ])
                          }),
                          _c("td", { staticClass: "border-right" }, [
                            _c("p", { staticClass: "text-medium blackLight" }, [
                              _vm._v(_vm._s(row.sinister_total))
                            ])
                          ]),
                          _c("td", { staticClass: "border-right" }, [
                            _c("div", { staticClass: "canvas-wrapper" }, [
                              _vm.selectedWeeks.length > 1
                                ? _c("canvas", {
                                    attrs: { id: "count-graph_" + index }
                                  })
                                : _vm._e()
                            ])
                          ])
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          ]),
          _vm.hasData
            ? _c(
                "div",
                { staticClass: "grid grid--jc-bottom mg mg--t-4" },
                [
                  _c("ma-paginator", {
                    staticClass: "mg mg--t-2 mg--b-4",
                    attrs: {
                      current: _vm.filtersData.currentPage,
                      total: _vm.filtersData.totalPages
                    },
                    on: {
                      "page:update": _vm.handlePageUpdate,
                      "page:set": _vm.handlePageSet
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.hasData
            ? _c("ma-empty", {
                attrs: {
                  icon: "recherche",
                  title: _vm.$t("common.noresults.short"),
                  descr: _vm.$t("common.noresults.long")
                }
              })
            : _vm._e(),
          _c("ma-loader", { class: { active: _vm.isLoaderActive } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }